<!--
 * @Description: 
 * @Author: 赵大壮
 * @Date: 2023-11-23 17:56:46
 * @LastEditTime: 2024-12-02 19:40:16
 * @LastEditors: 赵大壮
-->
<template>
    <div ref="mainView" class="content1">
        <div class="w-full" :style="{ height: mainHeight * 0.2 + 'px' }">
            <div class="w-full view-title" style="height: 40%;border-bottom: 1px solid #eeeeee">
                <el-page-header @back="actionBack" content="监控回放"></el-page-header>
            </div>
            <div class="w-full view-title">
                <div class="w-full flex item-center justify-between">
                    <div class="flex item-center " style="margin-top: 15px;">
                        <el-date-picker style="width: 200px;" v-model="selectedDate" type="datetime"
                            placeholder="选择日期时间" value-format="yyyy-MM-ddTHH:mm:ss" @change="actionSelectedDate"
                            @focus="focus">
                        </el-date-picker>
                        <el-button style="margin-left: 10px" type="primary" v-if="selectedDate"
                            @click="actionDoPlay">播放</el-button>
                    </div>
                    <NYProgressDeviceState v-if="playUrl" style="width: 1000px;background-color: black;"
                        :videoRecords="recordList" :currentTime="currentTime" @changCurrentTime="actionCurrentTime">
                    </NYProgressDeviceState>
                </div>
            </div>
        </div>
        
        <!-- <div class="w-full flex item-center justify-center"
            :style="{ height: mainHeight * 0.8 + 'px', backgroundColor: '#333333', marginTop: '5px' }">
            <JessibucaDemo v-show="playUrl" :videoUrl="playUrl" :style="{ width: videoWidth + 'px', height: videoHeight + 'px' }"/> 
        </div> -->

         <div class="w-full flex item-center justify-center"
            :style="{ height: mainHeight * 0.8 + 'px', backgroundColor: '#333333', marginTop: '5px' }">
             <!-- <div :style="{ width: videoWidth + 'px', height: videoHeight + 'px' }" v-html="playUrl"> </div> -->
             <!-- <div :style="{ width: videoWidth + 'px', height: videoHeight + 'px' }" v-html="playUrl"> </div> -->
             <iframe ref='recordView' id="recordView" scrolling='no' :width=" videoWidth + 'px'" :height="videoHeight + 'px'"   :src='playUrl' frameborder='0'></iframe>
         </div> 
    </div>
</template>

<script>
import moment from 'moment'
// import JessibucaDemo from '../../../components/jessibucaDemo.vue';
import NYProgressDeviceState from "./NYProgressDeviceState.vue"
export default {
    data() {
        return {
            mediaIp: '',
            mediaPort: '',
            chid: '',
            mainWidth: 0,
            mainHeight: 0,
            videoWidth: 0,
            videoHeight: 0,
            selectedDateRang: '',
            begintime: 0,
            endtime: 0,
            listDate: [],
            selectedDate: '',
            listTime: [],
            selectedTime: '',
            playUrl: '',
            recordList: [],
            currentTime: (new Date().getTime() / 1000)
        }
    },
    components: {
        // JessibucaDemo,
        'NYProgressDeviceState': NYProgressDeviceState
    },
    created() {
        this.chid = this.$route.query.id
        this.mediaIp = this.$route.query.mediaIp
        this.mediaPort = this.$route.query.mediaPort

    },
    mounted() {
        this.mainHeight = this.$refs.mainView.offsetHeight
        this.videoHeight = (this.mainHeight * 0.78 - 20)
        this.videoWidth = this.videoHeight * 16 / 9
    },
    beforeDestroy(){
        this.playUrl = "";
    },
    computed: {
    },
    methods: {
        actionBack() {
            this.$router.back()
        },
        actionSearchecord() {
            this.playUrl = ''
            this.listDate = []
            this.selectedDate = ''
            let loading = this.$loading()
            this.$jessibucaPostJson(`jessibuca/searchrecord`, { chid: this.chid, begintime: this.begintime.toString(), endtime: this.endtime.toString() })
                .then(res => {
                    loading.close()
                    console.log(res)
                    if (res.code == 200 && res.data && res.data.length > 0) {
                        this.listDate = res.data
                        this.selectedDate = this.listDate[0]
                        this.actionSearchrecordbydate()
                    }
                },
                    error => {
                        loading.close()
                        this.$message.error(error)
                    })
        },
        actionSearchrecordbydate() {
            this.playUrl = ''
            this.listTime = []
            this.selectedTime = ''
            let loading = this.$loading()
            let startDate = this.selectedDate.split("T")[0];
            let startTime = this.selectedDate.split("T")[1];
            let startHour = parseInt(startTime.split(":")[0]);
            let endHour = parseInt(startTime.split(":")[0]);
            let startMint = parseInt(startTime.split(":")[1]);
            let endMint = parseInt(startTime.split(":")[1]);
            startMint = startMint - 15;
            if (startMint < 0) {
                if (startHour == 0) {
                    startMint = 0;
                } else {
                    --startHour;
                    startMint = 60 - (Math.abs(startMint));
                }
            }
            endMint = endMint + 15;
            if (endMint > 60) {
                endHour = endHour >= 23 ? 23 : endHour + 1;
                endMint = endMint - 60;
            }
            let beginTime = startDate.replace(/-/g, "") + "" + (startHour < 10 ? "0" + startHour : startHour) + "" + (startMint < 10 ? "0" + startMint : startMint) + "00";
            let endTime = startDate.replace(/-/g, "") + "" + (endHour < 10 ? "0" + endHour : endHour) + "" + (endMint < 10 ? "0" + endMint : endMint) + "00";
            this.$jessibucaPostJson(`jessibuca/searchrecord`, { chid: this.chid, begintime: beginTime, endtime: endTime })
                .then(res => {
                    loading.close()
                    console.log(res)
                    if (res.code == 200 && res.data && res.data.length > 0) {
                        let isHaveRecord = false;
                        for (const item of res.data) {
                            if (item == startDate) {
                                isHaveRecord = true;
                                break;
                            }
                        }
                        if (!isHaveRecord) {
                            this.$message.error('该时间没有回放，开始播放最近回放');
                        }
                        let begintime = this.selectedDate
                        this.actionShowPlayView(begintime);
                        this.actionGetRecordInfo(startDate);
                    } else {
                        this.$message.error('该时间没有回放');
                    }
                }, error => {
                    loading.close()
                    this.$message.error(error)
                })
        },
        actionShowPlayView(begintime) {
            // this.playUrl =`http://192.168.184.1:8000/play_record.html?stream=${this.chid}&begintime=${begintime}`;
            // let webUrl =`http://192.168.184.1:8000/play_record.html?stream=${this.chid}&begintime=${begintime}`;
            // this.playUrl  =`http://${this.mediaIp}:${this.mediaPort}/player/play_record.html?stream=${this.chid}&begintime=${begintime}`;
			this.playUrl  =`https://zhwyjk.kmyhwy.cn/player/play_record.html?stream=${this.chid}&begintime=${begintime}`;
            // console.log("webUrl::::"+webUrl)
            // this.playUrl = "<iframe ref='recordView' scrolling='no' width='100%' height='100%'   src='" + webUrl + "' frameborder='0'></iframe>"
            // this.playUrl = playUrl
        },
        actionGetRecordInfo(trueDate) {
            this.currentTime = new Date(this.selectedDate).getTime() / 1000;
            this.$jessibucaPostJson(`jessibuca/searchrecordbydate`, { chid: this.chid, date: trueDate })
                .then(res => {
                    console.log(res)
                    if (res.code == 200 && res.data && res.data.length > 0) {
                        for (const item of res.data) {
                            this.recordList.push({
                                starttime: new Date(item.begin).getTime() / 1000,
                                endtime: new Date(item.end).getTime() / 1000
                            });
                        }
                    }
                },
                    error => {
                        loading.close()
                        this.$message.error(error)
                    })
        },
        actionSelectedRange(value) {
            console.log(value)
            this.begintime = 0
            this.endtime = 0
            if (value) {
                if (value[0] == value[1]) {
                    this.$message.error('两个日期不能相同');
                    return
                }
                this.begintime = value[0]
                this.endtime = value[1]
                this.actionSearchecord()
            }
        },
        actionSelectedDate(value) {
            console.log(value)
            this.selectedDate = value
        },
        actionDoPlay() {
            this.actionSearchrecordbydate()

            // let begintime = this.selectedDate
            // let playUrl = 'http://' + this.mediaIp + ':280/playback/' + this.chid + '.flv?playback=1&begintime=' + begintime
            // console.log('playUrl:::', playUrl)
            // let webUrl = 'http://' + this.mediaIp + ':' + this.mediaPort + '/player/play_flv.html?type=record&url=' + encodeURIComponent(playUrl)
            // this.playUrl = "<iframe scrolling='no' width='100%' height='100%'   src='" + webUrl + "' frameborder='0'></iframe>"

            // let loading = this.$loading()
            // this.$cwijGet(`jessibuca/stoprecord`, { chid: this.chid })
            // .then(res => {
            //     loading.close()
            //     if (res.code == 200) {
            //         let begintime = this.selectedDate + 'T' + this.selectedTime
            //         let playUrl = 'http://' + this.mediaIp + ':280/playback/' + this.chid + '.flv?playback=1&begintime=' + begintime
            //         console.log('playUrl:::', playUrl)
            //         let webUrl = 'http://' + this.mediaIp + ':' + this.mediaPort + '/player/play_flv.html?type=record&url=' + encodeURIComponent(playUrl)
            //         this.playUrl = "<iframe scrolling='no' width='100%' height='100%'   src='" + webUrl + "' frameborder='0'></iframe>"
            //     }
            // },
            // error => {
            //     loading.close()
            //     this.$message.error(error)
            // })
        },
        actionCurrentTime(current) {
            this.currentTime = current;
            let curDate = moment(new Date(current * 1000)).format('YYYY-MM-DDTHH:mm:ss');
            console.log("12312312312312312")
            console.log(this.$refs.recordView)
            // this.$refs.recordView.contentWindow.doMove(curDate)
            this.$refs.recordView.contentWindow.postMessage("moveTime::"+curDate,"*")

            // this.actionShowPlayView(curDate)
        },
        focus() {
            this.$nextTick(() => {
                document
                    .getElementsByClassName('el-button--text')[0]
                    .setAttribute('style', 'display:none')
            })
        }
    }
}
</script>

<style lang="scss" scoped>
.content1 {
    width: 100%;
    height: 100%;
    background-color: #ffffff;
    transform: translate(0);
    box-sizing: border-box;
}

.w-full {
    width: 100%;
}

.h-full {
    height: 100%;
}

.flex {
    display: flex
}

.item-center {
    align-items: center;
}

.justify-center {
    justify-content: center
}

.justify-between {
    justify-content: space-between
}

.view-title {
    display: flex;
    align-items: center;
    padding: 0 15px;
    box-sizing: border-box;
}

// 全局设置隐藏时间选择器此刻按钮
.el-button--primary .el-button__text {
    display: none;
}
</style>